<template>
  <transition name="fade">
    <div
      class="prompt-container"
      v-if="showPrompt"
    >
      <div
        class="prompt"
        @touchmove.prevent
      />
      <slot />
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Prompt',
    props: {
      showPrompt: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/transition.scss";
  @import "../assets/common.scss";
</style>
